import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  url: string = environment.api.endpoint;

  constructor(private http: HttpClient) { }

  getIterationHisotryCounts(id: any): any {
    return this.http.get(`${this.url}/dashboard/iterationhistory/counts/${id}`);
  }

  getOutingsAndIterationsByOrganization(id: any): any {
    return this.http.get(`${this.url}/dashboard/outings/organization/${id}`);
  }
}
